/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Swarmind API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ApiAddressGetOutput } from '../models';
// @ts-ignore
import { ApiAddressPostInput } from '../models';
// @ts-ignore
import { ApiTrialBalanceGetOutput } from '../models';
// @ts-ignore
import { ApiTrialBalancePostInput } from '../models';
// @ts-ignore
import { RestErrResponse } from '../models';
/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns amount of trial balance
         * @summary Trial balance Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc6: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trial_balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates an email linked record of trial balance, which will work as a survey bonus after registration
         * @summary Trial balance Post
         * @param {ApiTrialBalancePostInput} [apiTrialBalancePostInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc7: async (apiTrialBalancePostInput?: ApiTrialBalancePostInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/survey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTrialBalancePostInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes user crypto address
         * @summary Address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns stored user crypto address
         * @summary Address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stores user crypto address
         * @summary Address
         * @param {ApiAddressPostInput} [apiAddressPostInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAddress: async (apiAddressPostInput?: ApiAddressPostInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAddressPostInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns amount of trial balance
         * @summary Trial balance Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewAPIServiceFunc6(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTrialBalanceGetOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewAPIServiceFunc6(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentsApi.apiNewAPIServiceFunc6']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Creates an email linked record of trial balance, which will work as a survey bonus after registration
         * @summary Trial balance Post
         * @param {ApiTrialBalancePostInput} [apiTrialBalancePostInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewAPIServiceFunc7(apiTrialBalancePostInput?: ApiTrialBalancePostInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewAPIServiceFunc7(apiTrialBalancePostInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentsApi.apiNewAPIServiceFunc7']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Deletes user crypto address
         * @summary Address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAddress(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAddress(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentsApi.deleteAddress']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns stored user crypto address
         * @summary Address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddress(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAddressGetOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddress(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentsApi.getAddress']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Stores user crypto address
         * @summary Address
         * @param {ApiAddressPostInput} [apiAddressPostInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAddress(apiAddressPostInput?: ApiAddressPostInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAddress(apiAddressPostInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PaymentsApi.setAddress']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * Returns amount of trial balance
         * @summary Trial balance Get
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc6(options?: RawAxiosRequestConfig): AxiosPromise<ApiTrialBalanceGetOutput> {
            return localVarFp.apiNewAPIServiceFunc6(options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an email linked record of trial balance, which will work as a survey bonus after registration
         * @summary Trial balance Post
         * @param {PaymentsApiApiNewAPIServiceFunc7Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc7(requestParameters: PaymentsApiApiNewAPIServiceFunc7Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiNewAPIServiceFunc7(requestParameters.apiTrialBalancePostInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes user crypto address
         * @summary Address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAddress(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns stored user crypto address
         * @summary Address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddress(options?: RawAxiosRequestConfig): AxiosPromise<ApiAddressGetOutput> {
            return localVarFp.getAddress(options).then((request) => request(axios, basePath));
        },
        /**
         * Stores user crypto address
         * @summary Address
         * @param {PaymentsApiSetAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAddress(requestParameters: PaymentsApiSetAddressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setAddress(requestParameters.apiAddressPostInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentsApi - interface
 * @export
 * @interface PaymentsApi
 */
export interface PaymentsApiInterface {
    /**
     * Returns amount of trial balance
     * @summary Trial balance Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    apiNewAPIServiceFunc6(options?: RawAxiosRequestConfig): AxiosPromise<ApiTrialBalanceGetOutput>;

    /**
     * Creates an email linked record of trial balance, which will work as a survey bonus after registration
     * @summary Trial balance Post
     * @param {ApiTrialBalancePostInput} [apiTrialBalancePostInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    apiNewAPIServiceFunc7(apiTrialBalancePostInput?: ApiTrialBalancePostInput, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Deletes user crypto address
     * @summary Address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    deleteAddress(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Returns stored user crypto address
     * @summary Address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    getAddress(options?: RawAxiosRequestConfig): AxiosPromise<ApiAddressGetOutput>;

    /**
     * Stores user crypto address
     * @summary Address
     * @param {ApiAddressPostInput} [apiAddressPostInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    setAddress(apiAddressPostInput?: ApiAddressPostInput, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for apiNewAPIServiceFunc7 operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiNewAPIServiceFunc7Request
 */
export interface PaymentsApiApiNewAPIServiceFunc7Request {
    /**
     * 
     * @type {ApiTrialBalancePostInput}
     * @memberof PaymentsApiApiNewAPIServiceFunc7
     */
    readonly apiTrialBalancePostInput?: ApiTrialBalancePostInput
}

/**
 * Request parameters for setAddress operation in PaymentsApi.
 * @export
 * @interface PaymentsApiSetAddressRequest
 */
export interface PaymentsApiSetAddressRequest {
    /**
     * 
     * @type {ApiAddressPostInput}
     * @memberof PaymentsApiSetAddress
     */
    readonly apiAddressPostInput?: ApiAddressPostInput
}

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI implements PaymentsApiInterface {
    /**
     * Returns amount of trial balance
     * @summary Trial balance Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public apiNewAPIServiceFunc6(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).apiNewAPIServiceFunc6(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates an email linked record of trial balance, which will work as a survey bonus after registration
     * @summary Trial balance Post
     * @param {PaymentsApiApiNewAPIServiceFunc7Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public apiNewAPIServiceFunc7(requestParameters: PaymentsApiApiNewAPIServiceFunc7Request = {}, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).apiNewAPIServiceFunc7(requestParameters.apiTrialBalancePostInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes user crypto address
     * @summary Address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public deleteAddress(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).deleteAddress(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns stored user crypto address
     * @summary Address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getAddress(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getAddress(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stores user crypto address
     * @summary Address
     * @param {PaymentsApiSetAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public setAddress(requestParameters: PaymentsApiSetAddressRequest = {}, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).setAddress(requestParameters.apiAddressPostInput, options).then((request) => request(this.axios, this.basePath));
    }
}

